export const fmtMXN = (value) =>
  new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);

/**
 * Derive price per kilo from a variant or a product.
 * Accepts: { price, weight_g } — returns formatted "$X / kg" string or null if not derivable.
 */
export const pricePerKg = ({ price, weight_g }) => {
  if (!price || !weight_g || weight_g <= 0) return null;
  const perKg = (price * 1000) / weight_g;
  return fmtMXN(Math.round(perKg));
};
